<h2>{{ 'circ_newFromPrepared_title' | i18n }}</h2>
